import { render, staticRenderFns } from "./ProGeneralInfo.vue?vue&type=template&id=5f53cde7&scoped=true"
import script from "./ProGeneralInfo.vue?vue&type=script&lang=ts"
export * from "./ProGeneralInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f53cde7",
  null
  
)

export default component.exports